<template>
  <div id="left-Menu">
    <el-row>
      <el-col :span="24">
        <el-menu
          :default-active="onRoutes"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          router
        >
          <template v-for="(level1,index1) in menuList">
            <el-submenu
              :index="index1+''"
              :key="level1.id"
              v-if="level1.children"
            >
              <template slot="title">
                <i :class="[level1.icon?level1.icon:'el-icon-menu']"></i>
                <span>{{level1.title}}</span>
              </template>
              <template v-for="(level2,index2) in level1.children">
                <el-menu-item
                  :index="handleUrl(level2.pathUrl)"
                  :key="level2.id"
                  v-if="!level2.children"
                >
                  <i :class="[level2.icon?level2.icon:'el-icon-menu']"></i>
                  <span>{{level2.title}}</span>
                </el-menu-item>
                <el-submenu
                  :index="index1+'-'+index2"
                  v-else
                  :key="level2.id"
                >
                  <template slot="title">{{level2.title}}</template>
                  <template v-for="level3 in level2.children">
                    <el-menu-item
                      :index="handleUrl(level3.pathUrl)"
                      :key="level3.id"
                    >{{level3.title}}</el-menu-item>
                  </template>
                </el-submenu>
              </template>
            </el-submenu>
            <el-menu-item
              :index="handleUrl(level1.pathUrl)"
              :key="level1.id"
              v-else
            >
              <i :class="[level1.icon?level1.icon:'el-icon-menu']"></i>
              <span slot="title">{{level1.title}}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuList: [
        {
          title: '会员管理',
          id: '1',
          icon: 'el-icon-s-custom',
          pathUrl: '/membersList'
        },
        {
          title: '项目管理',
          id: '2',
          icon: 'el-icon-document-copy',
          pathUrl: '/projectList'
        },
        {
          title: '活动招募',
          id: '6',
          icon: 'el-icon-help',
          pathUrl: '/mutualHelpList'
        },
        {
          title: '酬金管理',
          id: '3',
          icon: 'el-icon-coin',
          pathUrl: '/remuneration',
          children: [
            {
              title: '交易流水',
              id: '3-1',
              icon: 'el-icon-money',
              pathUrl: '/remuneration/dealFlow'
            },
            {
              title: '财务结算',
              id: '3-2',
              icon: 'el-icon-coordinate',
              pathUrl: '/remuneration/settlement'
            },
            {
              title: '项目汇总',
              id: '3-3',
              icon: 'el-icon-notebook-1',
              pathUrl: '/remuneration/summary'
            }
          ]
        },
        {
          title: '管理员设置',
          id: '4',
          icon: 'el-icon-s-tools',
          pathUrl: '/manager'
        }
        // {
        //   title: '多级目录',
        //   id: '5',
        //   icon: '',
        //   pathUrl: '',
        //   children: [
        //     {
        //       title: '二级目录一',
        //       id: '5-1',
        //       icon: '',
        //       pathUrl: ''
        //     },
        //     {
        //       title: '二级目录二',
        //       id: '5-2',
        //       icon: '',
        //       pathUrl: ''
        //     },
        //     {
        //       title: '二级目录三',
        //       id: '5-3',
        //       icon: '',
        //       pathUrl: '',
        //       children: [
        //         {
        //           title: '三级目录一',
        //           id: '5-3-1',
        //           icon: '',
        //           pathUrl: ''
        //         }
        //       ]
        //     }
        //   ]
        // }
      ]
    }
  },
  computed: {
    onRoutes() {
      return this.$route.path
    }
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    },
    handleUrl(url) {
      return `${url}`
    }
  }
}
</script>
<style lang='scss'>
#left-Menu {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: #fff;
  .el-menu {
    border: none;
  }
}
</style>
